import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {

    createChannel = new Subject()
    typeChannel = new Subject()
    employeeListChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({ status: apiResponse.INITIAL })
        this.typeChannel.next({ status: apiResponse.INITIAL })
        this.employeeListChannel.next({ status: apiResponse.INITIAL })
    }

    fetchEmployeeList = async (query) => {
        this.employeeListChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchEmployeeList(query).then((result) => {
            this.employeeListChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.employeeListChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

    fetchCreate = async (query) => {
        this.createChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.createChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

    fetchType = async (query, cancelToken) => {
        this.typeChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchType(query, cancelToken).then((result) => {
            this.typeChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.typeChannel.next({ status: apiResponse.ERROR, data: error})
        })
    }

}

export default CreateBloc